import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganizationContext } from '../../../utils/context/OrganizationContext.tsx';

export const useConfirmationModal = () => {
  const { t } = useTranslation();
  const { open, setLoading, close } = useConfirmationDialog();
  const { useApiKeyDelete } = useOrganizationContext();
  const { deleteApiKey } = useApiKeyDelete();

  const handleOnConfirmed = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        await deleteApiKey(id);
      } finally {
        setLoading(false);
      }

      close();
    },
    [close, deleteApiKey, setLoading]
  );

  return useCallback(
    (id: string, name: string) => {
      open({
        confirmationButtonColor: 'error',
        confirmationLabel: t('Delete'),
        content: (
          <DialogContent dividers>
            <Typography>{t("You're about to delete API key:")} </Typography>
            <Typography variant="body1Bold">{name}</Typography>
          </DialogContent>
        ),
        customContent: true,
        hideConfirm: false,
        onConfirmed: () => handleOnConfirmed(id),
        title: t('Delete API key'),
      });
    },
    [handleOnConfirmed, open, t]
  );
};
